import { styles } from './CategoryText.css';
import React from 'react';

import CalloutFont from '@jbhi-fi/lanyard-ui/font/CalloutFont';
import { FlexText } from '../../FlexText/FlexText';

export type CategoryTextProps = {
  color: React.CSSProperties['color'];
  children: string;
  className?: string;
  maxFontSizePx?: number;
};

export const CategoryText = ({ children, color, className, maxFontSizePx }: CategoryTextProps) => {
  return (
    <FlexText className={className} maxFontSizePx={maxFontSizePx}>
      <CalloutFont className={styles.categoryText} as="span" style={{ color }}>
        {children}
      </CalloutFont>
    </FlexText>
  );
};
